module.exports = __webpack_public_path__ + "cement/img/组 16@2x.6c331a6e.png";